import { render, staticRenderFns } from "./SharedWithSocials.vue?vue&type=template&id=36e2ece1&scoped=true"
import script from "./SharedWithSocials.vue?vue&type=script&lang=js"
export * from "./SharedWithSocials.vue?vue&type=script&lang=js"
import style0 from "./SharedWithSocials.vue?vue&type=style&index=0&id=36e2ece1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e2ece1",
  null
  
)

export default component.exports